import { render, staticRenderFns } from "./miniadmin.vue?vue&type=template&id=6db71b5e"
import script from "./miniadmin.vue?vue&type=script&lang=js"
export * from "./miniadmin.vue?vue&type=script&lang=js"
import style0 from "./miniadmin.vue?vue&type=style&index=0&id=6db71b5e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports